module.exports = __webpack_public_path__ + "static/img/JAKE-ROGERS.77e3784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JAKE-ROGERS.jpg
// module id = bAYn
// module chunks = 0